import React, {useState} from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import ScienceIcon from "@mui/icons-material/Science";
import FactoryIcon from "@mui/icons-material/Factory";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InsightsIcon from "@mui/icons-material/Insights";
import BusinessIcon from "@mui/icons-material/Business";
import BarChartIcon from "@mui/icons-material/BarChart";
import KazakhstanMap from "../Map";
import {kazakhstanRegions} from "../../../model/regions";

const ChemistryPetrochemistryPage: React.FC = () => {

    const [selectedRegion, setSelectedRegion] = useState<string | null>(null);
    const [hoveredRegion, setHoveredRegion] = useState<string | null>(null);

    const handleRegionClick = (region: any) => {
        setSelectedRegion(region.name);
        console.log('Выбран регион:', region);
    };

    const handleRegionHover = (region: any) => {
        setHoveredRegion(region ? region.name : null);
    };

    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            {/* Заголовок */}
            <Typography variant="h4" fontWeight={700} gutterBottom>
                Химия и нефтехимия
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Ключевой индустриальный кластер переработки углеводородов и выпуска высокодоходной продукции в Республике Казахстан
            </Typography>

            {/* Потенциал отрасли */}
            <Paper sx={{ p: 4, mb: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Потенциал отрасли и приоритеты
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <List>
                            <ListItem>
                                <ListItemIcon><FactoryIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="Казахстанское производство для переработки углеводородов до 2030" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><ScienceIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="Производство высокодоходной продукции: полипропилен, полистирол, поливинилхлорид, сода каустическая и др." />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><LocationOnIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="Индустриальная химия: Павлодарская, Мангистауская обл., Аксай, Таразская обл. и ЮКО" />
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                width: '100%',
                                backgroundColor: '#e3f2fd',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 2,
                                color: '#1976d2',
                                fontWeight: 600,
                            }}
                        >

                            <KazakhstanMap
                                regions={kazakhstanRegions}
                                onRegionClick={handleRegionClick}
                                onRegionHover={handleRegionHover}
                                defaultFill="#5764f7"
                                hoverFill="#4254f5"
                                activeFill="#3244d0"
                            />

                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            {/* Ключевые показатели */}
            <Paper sx={{ p: 4, mb: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Ключевые показатели (на 2024 год)
                </Typography>
                <Grid container spacing={2}>
                    {[
                        { label: "Объем отрасли", value: "4,8 трлн ₸" },
                        { label: "Экспорт продукции", value: "2,7 млрд $" },
                        { label: "Проектная мощность", value: "15,6 млн тонн" },
                        { label: "Производство", value: "520 тыс. тонн" },
                        { label: "Предприятий", value: ">1050" },
                        { label: "Рост за 5 лет", value: "+38%" },
                    ].map((item, idx) => (
                        <Grid item xs={12} sm={6} md={4} key={idx}>
                            <Paper variant="outlined" sx={{ p: 2, textAlign: "center" }}>
                                <Typography variant="h6" fontWeight={700}>
                                    {item.value}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {item.label}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Paper>

            {/* Возможности для капиталовложений */}
            <Paper sx={{ p: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Возможности для капиталовложений
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <ListItem disablePadding>
                            <ListItemIcon><InsightsIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="Реализация Нацпроекта до 2029 года по развитию химической промышленности" />
                        </ListItem>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <ListItem disablePadding>
                            <ListItemIcon><BusinessIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="Преференции в СЭЗ 'National Industrial Petrochemical Technopark', Атырау" />
                        </ListItem>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <ListItem disablePadding>
                            <ListItemIcon><BarChartIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="Поддержка от Компания, BRK, QazIndustry" />
                        </ListItem>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    );
};

export default ChemistryPetrochemistryPage;